<template>
  <div class="dashboard">
    <!-- Sidebar -->
    <div class="sidebar-fixed position-fixed ">
      <a href="#" class="logo-wrapper waves-effect"> </a>

      <div class="list-group list-group-flush">
        <div
          class="nav flex-column nav-pills"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <router-link
            class="nav-link list-group-item waves-effect active"
            id="v-pills-home-tab"
            data-toggle="pill"
            href="#v-pills-home"
            role="tab"
            aria-controls="v-pills-home"
            aria-selected="true"
            to="/dashboard/home"
            ><i class="fas fa-home mr-md-3"></i
            ><span class="d-none d-md-inline-block">Home</span>
          </router-link>
          <router-link
            class="nav-link list-group-item waves-effect"
            id="v-pills-profile-tab"
            data-toggle="pill"
            href="#v-pills-profile"
            role="tab"
            aria-controls="v-pills-profile"
            aria-selected="false"
            to="profile"
          >
            <i class="fas fa-user mr-md-3"></i
            ><span class="d-none d-md-inline-block">Profile</span></router-link
          >
          <router-link
            class="nav-link list-group-item waves-effect"
            id="v-pills-settings-tab"
            data-toggle="pill"
            href="#v-pills-settings"
            role="tab"
            aria-controls="v-pills-settings"
            aria-selected="false"
            to="/dashboard/articles"
          >
            <i class="fas fa-list-alt mr-md-3"></i
            ><span class="d-none d-md-inline-block"
              >mes articles</span
            ></router-link
          >
          <router-link
            class="nav-link list-group-item waves-effect"
            id="v-pills-statutArticle-tab"
            data-toggle="pill"
            href="#v-pills-statutArticle"
            role="tab"
            aria-controls="v-pills-statutArticle"
            aria-selected="false"
            to="/"
            ><i class="fas fa-envelope mr-md-3"></i
            ><span class="d-none d-md-inline-block"
              >statut des articles</span
            ></router-link
          >
          <router-link
            class="nav-link list-group-item waves-effect"
            id="v-pills-storeStting-tab"
            data-toggle="pill"
            href="#v-pills-storeStting"
            role="tab"
            aria-controls="v-pills-storeStting"
            aria-selected="false"
            to="/dashboard/store-stat"
            ><i class="fa fa-shopping-cart mr-md-3" aria-hidden="true"></i
            ><span class="d-none d-md-inline-block"
              >store statistic</span
            ></router-link
          >
        </div>
      </div>
    </div>
    <!-- Sidebar -->
    <main>
      <div class="container-fluid pt-3">
        <!-- Heading -->
        <div class="card mb-4 fadeIn">
          <!--Card content-->
          <div class="card-body d-sm-flex justify-content-between">
            <h4 class="mb-2 mb-sm-0 pt-1">
              <a href="../index.html" target="_blank">Home Page</a>
              <span>/</span>
              <span id="chemin">Tableau de bord</span>
            </h4>

            <form class="d-flex justify-content-center">
              <!-- Default input -->
              <input
                type="search"
                placeholder="Rechercher"
                aria-label="Search"
                class="form-control"
              />
              <button class="btn btn-primary btn-sm my-0" type="submit">
                <i class="fas fa-search"></i>
              </button>
            </form>
          </div>
        </div>
        <!-- Heading -->

        <router-view name="a"></router-view>
        <router-view name="b"></router-view>
        <router-view name="c"></router-view>
        <router-view name="d"></router-view>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "Dashboard"
};
</script>

<style lang="scss" scoped>
.sidebar-fixed {
  height: 100vh;
  width: 270px;
  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
    0 2px 10px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  z-index: 1050;
  background-color: #000098;
  padding: 0 1.5rem 1.5rem;
}
.sidebar-fixed .list-group .active {
  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
    0 2px 10px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  -webkit-border-radius: 5px;
  border-radius: 5px;
}
.sidebar-fixed .logo-wrapper {
  padding: 2.5rem;
}
.sidebar-fixed .logo-wrapper img {
  max-height: 50px;
}
@media (min-width: 1200px) {
  .page-footer,
  main {
    padding-left: 270px;
  }
}
@media (max-width: 1199.98px) {
  .sidebar-fixed {
    display: none;
  }
}
</style>